import { useSelector } from "react-redux";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { RootState } from "../../reducers";
import { ObjectUtils } from "../../utils";
import { AlertComponent } from "../Alert";
import { ButtonComponent, NextPrevComponent } from "../Button";
import { GridComponent } from "../Card";
import { useLayoutEffect } from "react";

export const ModalComponent = ({ children, ...props }: any) => {
  const {
    showModal,
    dialogClass,
    head,
    body,
    footer,
    clickHandler,
    css,
    showHeaderCloseBtn = true,
    portalContainerSelector,
    backdropClassName,
    modalClassName,
  } = props?.modalObject || {};
  const contentFooter = useSelector((state: RootState) => state?.common?.contentFooter?.contentResource?.contents);
  const closeButtonText = ObjectUtils.extractLabelFromObject(contentFooter || {}, "btnClose");
  const portalContainer = portalContainerSelector ? document.querySelector(portalContainerSelector) : null;


  // Address AODA concern FLEXS-11039: Include accessible name for dialog element
  // Related GitHub issue: https://github.com/reactstrap/reactstrap/issues/2822
  // Reference: https://github.com/react-bootstrap/react-bootstrap/issues/5084
  useLayoutEffect(() => {
    if (showModal) {
      const scopedContainer = portalContainer || document;
      // Target the outer div with role="dialog"
      const dialogElement = scopedContainer.querySelector('[role="dialog"]');

      if (dialogElement) {
        // Add aria-label as fallback
        if (!dialogElement.hasAttribute('aria-label')) {
          dialogElement.setAttribute('aria-label', 'Dialog');
        }

        // Add aria-labelledby to point to the heading
        if (!dialogElement.hasAttribute('aria-labelledby')) {
          dialogElement.setAttribute('aria-labelledby', 'modalHeading modalSubtitle');
        }
      }
    }
  }, [showModal, portalContainer]);

  const modalHeader = (
    <div className={css?.modalHeader || 'modal-header'}>
      <h1 className={css?.modalTitle || 'modal-title'} >
        <span id="modalHeading" dangerouslySetInnerHTML={{ __html: head?.modalTitle || '' }} />
        <span id="modalSubtitle" className="visuallyhidden" aria-hidden="true">dialog</span>
      </h1>
      {clickHandler && showHeaderCloseBtn && (
        <ButtonComponent
          btndata={[
            {
              variant: "close",
              ariaLabel: closeButtonText.display,
              display: "×",
              onSubmit: clickHandler
            }
          ]}
        />
      )}
    </div>
  );

  const modalBody = showModal && (
    <ModalBody className={`${body?.confirmBoxData?.wrapper ?? ""}${body?.bodyClass ?? ""}`}>
      {body?.confirmBoxData && (
        <>
          {body?.confirmBoxData?.messagetitle && (
            <h2 className={`modal-message-title ${body?.confirmBoxData?.messagetitleclass ?? ""}`} dangerouslySetInnerHTML={{ __html: body?.confirmBoxData?.messagetitle }} />
          )}
          {body?.confirmBoxData?.wrapper && <hr />}
          {body?.confirmBoxData?.messagetext && (
            <div className={`${body?.confirmBoxData?.messagepopclass ?? ""}`}>
              <div className={`${body?.confirmBoxData?.messagetextclass ?? ""}`} dangerouslySetInnerHTML={{ __html: body?.confirmBoxData?.messagetext }} />
            </div>
          )}
        </>
      )}
      {!body?.viewbodyMode &&
        body?.gridRowData?.map((item: any, index: number) => {
          return <GridComponent key={index} bodyData={item} rowdata={item[0]} />;
        })}

      {body?.messageText && <AlertComponent marginleft={false} propmessageType={body?.messageType} propmessage={body?.messageText} />}
      {body?.messageText1 && <div dangerouslySetInnerHTML={{
        __html: body?.messageText1
      }}></div>}
      {children && <>{children}</>}
      {body?.showNextPrev && (
        <div className="ml-btnslifechangeevent">
          <NextPrevComponent
            lastPage={false}
            firstPage={true}
            nextClick={body?.showNextPrev?.agreeDisclaimerPresses || ""}
            cancelClicked={body?.showNextPrev?.cancelClicked || ""}
            previousClick={body?.showNextPrev?.cancelClicked || ""}
            lblNext={body?.showNextPrev?.iAgree || ""}
            lblCancel={body?.showNextPrev?.idontAgree || ""}
            lblPrevious={body?.showNextPrev?.idontAgree || ""}
            showButtons={body?.showNextPrev?.showButtons || false}
            onClick={body?.showNextPrev?.onClick || ""}
          />
        </div>
      )}
    </ModalBody>
  );

  const modalFooter = (
    <>
      {footer?.footerChild && !footer?.footerData && (
        <ModalFooter className={`${css?.modalFooter ?? ""}`}>
          {footer.footerChild}
        </ModalFooter>
      )}
      {!footer?.footerChild && footer?.footerData && (
        <ModalFooter className={`ml-popupbuttons justify-content-between ${css?.modalFooter ?? ""}`}>
          <ButtonComponent btndata={footer?.footerData} />
        </ModalFooter>
      )}
    </>
  );

  return (
    <Modal
      labelledBy="modalHeading modalSubtitle"
      className={dialogClass}
      isOpen={showModal}
      toggle={clickHandler}
      centered
      container={portalContainer || undefined}
      backdropClassName={backdropClassName}
      modalClassName={modalClassName}
    >
      {modalHeader}
      {modalBody}
      {modalFooter}
    </Modal>
  );
};

export default ModalComponent;
